import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions
} from '@headlessui/react';
import classNames from 'classnames';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { DropdownOption } from '../input/dropdown/dropdownConfig';

// TODO: Comment up here
const SelectBase: FC<{
  options: DropdownOption[];
  value?: string;
  onSelect: (option: DropdownOption) => Promise<void> | void;
  onBlur?: (() => void) | undefined;
  disabled: boolean;
  className?: string;
  optionsClassName?: string;
  dataTestId?: string;
  inputElement: (open: boolean) => React.ReactNode;
}> = ({
  options,
  value,
  onSelect,
  onBlur,
  disabled,
  className,
  optionsClassName,
  dataTestId,
  inputElement
}) => {
  const handleChange = (selectedValue: string) => {
    const selectedOption = options.find((opt) => opt.value === selectedValue);
    if (selectedOption) {
      void onSelect(selectedOption);
    }
  };

  return (
    <Listbox
      value={value ?? ''}
      onChange={handleChange}
      disabled={disabled}
      as="div"
      data-test-id={dataTestId}
      className={twMerge('relative', className)}
    >
      {({ open }) => (
        <>
          <ListboxButton
            className="w-full group outline-hidden"
            onBlur={onBlur}
            data-test-id={`${dataTestId}-button`}
          >
            {/* This Input Element function as visible button */}
            {inputElement(open)}
          </ListboxButton>

          <ListboxOptions
            className={twMerge(
              'absolute w-full z-dropdown -mt-spacing-04 py-spacing-02 rounded-radius-02 bg-primary shadow-shadow-03 max-h-60 overflow-y-scroll outline-hidden',
              optionsClassName
            )}
          >
            {options.map((option) => (
              <React.Fragment key={option.value}>
                {option.dividerAbove && (
                  <div className="border-t border-secondary my-spacing-02" />
                )}

                <ListboxOption value={option.value} data-value={option.value}>
                  {({ focus, selected }) => (
                    <div
                      className={twMerge(
                        classNames(
                          'w-full px-spacing-04 py-spacing-03 desktop:py-spacing-02 hover:bg-secondary active:bg-tertiary cursor-pointer outline-hidden',
                          { 'bg-secondary': focus || selected }
                        )
                      )}
                    >
                      <p className="body-02 text-primary text-start">
                        {option.label}
                      </p>
                    </div>
                  )}
                </ListboxOption>
              </React.Fragment>
            ))}
          </ListboxOptions>
        </>
      )}
    </Listbox>
  );
};

export default SelectBase;
